import React, { useEffect } from 'react';
import { useApplicationStore, useTranslation, useUserInfoStore } from '@pascal/pascal-core';
import { gameStore } from '../../store/gameStore';
import { soundService } from '../../services/SoundService';

const WinNumbers = ({ winNumbersResult, winningAmount, isBetShop = false }) => {
  const t = useTranslation();
  const { isDemo } = useApplicationStore();
  const { currencySymbolOrCode } = useUserInfoStore();
  const { isBetsClosed } = gameStore;

  useEffect(() => {
    if (winningAmount && winningAmount > 0) {
      soundService.playWin();
    }
  }, [winningAmount]);

  if (!isBetsClosed) {
    return null;
  }

  return (
    <div className='roulette-win-number-wrp'>
      <div className={`roulette-win-number-cont ${winningAmount ? '' : 'type-1'}`}>
        {winNumbersResult && (
          <div className={`win-number-main-wrp type-${winNumbersResult.type}`}>
            <div className='win-number-main-wrp-number left'>
              <p className='win-p-number'>{winNumbersResult.numbers[0]}</p>
            </div>
            <div className='win-number-main-wrp-number center'>
              <p className='win-p-number'>{winNumbersResult.numbers[1]}</p>
            </div>
            <div className='win-number-main-wrp-number right'>
              <p className='win-p-number'>{winNumbersResult.numbers[2]}</p>
            </div>
            {isBetShop && <span className='win-coin-block' />}
          </div>
        )}
        {!!winningAmount && (
          <div className='game-result-wrp'>
            <p className='game-result-text'>{t('YOU_HAVE_WON')}</p>
            <p className='win-amount'>
              {winningAmount} {isDemo ? 'FUN' : currencySymbolOrCode}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WinNumbers;
